exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "label {\r\n\tfont-size: 10pt;\r\n\tfont-weight: normal;\r\n\tcolor: #444;\r\n} \r\n\r\n.ui-inputtext {\r\n\twidth: 98%;\r\n\tbackground: #ffffff;\r\n    color: #222222;\r\n    transition: .2s;\r\n}\r\n\r\n.buttonOn {\r\n    background-color: #e6e6e6;\r\n    border-color: #adadad;\r\n    box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/reports.component.css
// module id = 349
// module chunks = 0